import { useEffect } from "react";
import { useMotionValue, useSpring, useTransform, motion } from "framer-motion";
import { formatNumber } from "../../utils/formatters";
import styles from "./LiveCounter.module.css";

export interface LiveCounterProps {
  value: number;
  label: string;
  formatter?: (value: number) => string;
  size?: "small" | "medium" | "large";
}

const springConfig = { stiffness: 300, damping: 30 };

export function LiveCounter({
  value,
  label,
  formatter = formatNumber,
  size = "medium",
}: LiveCounterProps) {
  const motionValue = useMotionValue(value);
  const spring = useSpring(motionValue, springConfig);
  const display = useTransform(spring, (v) => formatter(Math.round(v)));

  useEffect(() => {
    motionValue.set(value);
  }, [motionValue, value]);

  return (
    <div
      className={`${styles.counter} ${styles[size]}`}
      data-testid="live-counter"
    >
      <motion.span className={styles.value}>{display}</motion.span>
      <span className={styles.label}>{label}</span>
    </div>
  );
}
